import React, { useEffect, useState } from 'react';
import MainApp from './MainApp';
import './App.css';
import LanguageSelector from './LanguageSelector';
import Cookies from 'js-cookie';


function App() {
  const [dir, setDir] = useState<'ltr' | 'rtl'>('ltr');

  const onLangChange = (lang: string) => {
    const isRtl = lang === 'ar';
    setDir(isRtl ? 'rtl' : 'ltr');
    // يضبط الـ <html> ككل
    document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    // لو تستخدم tailwindcss-rtl plugin
    document.documentElement.classList.toggle('rtl', isRtl);
  };

  useEffect(() => {
    const saved = Cookies.get('lang') || 'ar';
    onLangChange(saved);
  }, []);

  return (
    <div className="App" dir={dir}>
      <LanguageSelector onLangChange={onLangChange} />
      <MainApp />
    </div>
  );
}

export default App;
